<div class="admin-buttons-container">
    <div class="card">
        <div class="icon-container">
            <div class="icon">
                <div class="profil management"></div>
            </div>
        </div>
        <div class="title">Fonctionnalités</div>
        <div class="button-container">
            <frg-button routerLink="feature-flipping">Commencer</frg-button>
        </div>
    </div>
    <div class="card">
        <div class="icon-container">
            <div class="icon">
                <div class="profil management"></div>
            </div>
        </div>
        <div class="title">Gestion des rôles</div>
        <div class="button-container">
            <frg-button routerLink="role-management">Commencer</frg-button>
        </div>
    </div>
    <!-- <div class="card">
        <div class="icon-container">
            <div class="icon">
                <div class="user management"></div>
            </div>
        </div>
        <div class="title">Gestion des utilisateurs</div>
        <div class="button-container">
            <frg-button routerLink="user-management">Commencer</frg-button>
        </div>
    </div> -->
    <div class="card">
        <div class="icon-container">
            <div class="icon">
                <div class="office management"></div>
            </div>
        </div>
        <div class="title">Gestion des cabinets</div>
        <div class="button-container">
            <frg-button routerLink="office-management">Commencer</frg-button>
        </div>
    </div>
    <div class="card">
        <div class="icon-container">
            <div class="icon">
                <div class="office management"></div>
            </div>
        </div>
        <div class="title">Gestion JFSE</div>
        <div class="button-container">
            <frg-button routerLink="office-jfse">Commencer</frg-button>
        </div>
    </div>
    <div class="card">
        <div class="icon-container">
            <div class="icon">
                <div class="profil management"></div>
            </div>
        </div>
        <div class="title">Changer mon mot de passe</div>
        <div class="button-container">
            <frg-button (click)="goToRenewPassword()">Commencer</frg-button>
        </div>
    </div>
</div>
